module.exports = __webpack_public_path__ + "img/pay_storing_cloud.19cb4f78.png";